import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from '../service/theme.service';
import { DispatchService } from '../service/dispatch.service';
import {ClientInterface} from '../service/dispatch.service';
import { WebSocketService, WebSocketSubscription, BaseMessage, WebSocketTypeGuards } from "../service/websocket.service";
import { CognitoService } from '../service/cognito.service';
import { ChatService } from '../service/chat.service';

export interface Message{
  /* test interface */
 /*  owner:number,
  message:string */
  /* real interface */
  message_id:string,
  conversation_id:string,
  sender_sub:string,
  receiver_sub:string,
  content:string,
  media:File | Blob | null,
  message_type:string,
  status:string,
  timestamp:number,
  deleted:boolean,
  edited_at:string|null

}

@Component({
    selector: 'dispatch-contact-modal',
    templateUrl: './dispatch-contact-modal.component.html',
    styleUrl: './dispatch-contact-modal.component.css',
    standalone: false
})

export class DispatchContactModalComponent implements OnInit, OnDestroy {
  public clientContact:any /* :ClientInterface = {
    active: '',
    address: '',
    auto_collect: '',
    checked: false,
    client_id: '',
    client_logo: null,
    client_name: '',
    created: null,
    email: '',
    legal_name: '',
    modified: null,
    mws: '',
    phone_number: ''
  }
   */

  public communiation:boolean = false;
  public position:boolean = true;
  //change to right interfaces
  public chatLog: any = [{owner:2,message:'Problem detected'},{owner:1,message:'What is it?'}, {owner:2,message:'Bin on Fire'}, {owner:1,message:"🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥"}]; // the chat transcript 
  public newMessage: string = ''; // the new message
  public cognitoUsers: any[]=[]; // Array of cognito users
  private TargetUserSub: string = "";
  public selectedContact:any;
  private userSub:any;

  private wsLiveChat: WebSocketSubscription = {
    subscriber: "dispatch-network",
    messageType: "LIVE_CHAT",
    callback: this.wsLiveChatChatHandler,
  };
  public contacts:any;
  constructor(
    public theme: ThemeService,
    public dispatchService: DispatchService, //user contact and UI display
    private cognitoService: CognitoService,
    public webSocketService: WebSocketService, // duplex connections
    public chatService: ChatService // handles live chat
  ){}

  async ngOnInit(){
    this.clientContact = this.dispatchService.clientContact
    console.log(this.clientContact)
    console.log(await this.contacts)
    this.webSocketService.subscribe(this.wsLiveChat);
    //Get current user sub
    this.cognitoService.getCurrentUserSub().then(userSub => {
      this.userSub = userSub;
      console.log(this.userSub)
    });
  /*   this.cognitoUsers = await this.cognitoService.getAllUsers();
    console.log(this.cognitoUsers)
    await console.log(
      this.cognitoUsers.find((u) => {
        return (
          u.custom_client_id === this.clientContact.client_id ||
          u.custom_distributor_id === this.clientContact.client_id ||
          u.custom_operator_id === this.clientContact.client_id
        );
      })
    ); */
    console.log(this.clientContact.client_id)
    // CL4ccb363d4cd095d853
 } 
 ngOnDestroy(){
  this.webSocketService.unsubscribe(this.wsLiveChat);
  this.cognitoUsers = []
 }
 wsLiveChatChatHandler(message:BaseMessage){
    if (message.ACTION === 'CHAT_MESSAGE') {
      this.chatLog.push(message.CONTENT['message']);
    }
 }

 navigate(tab:number){
  switch(tab){
    case 1:
      this.communiation = false
      this.position = true
      break;
    case 2:
      this.communiation = true
      this.position = false
      break;

  }
 }
  closeModal(){
    this.dispatchService.isContactModalOpen = false;
  }
  sendMessage(){
    //Implenment Websocket calls
    const message = {
      owner:1,
      message: this.newMessage
    }
    if(message.message){
      this.chatLog.push(message)
      this.newMessage = ''
    }
  }
  openConversation(recipientSub:string){
    let usersubs= [
      this.userSub,
      recipientSub
    ]
    console.log(usersubs)
    //this.chatLog = this.chatService.getChatLog(usersubs)
  }
  generateRandomColor(): string {
    const randomColor = '#' + Math.floor(Math.random()*16777215).toString(16);
    return randomColor;
  }
  selectContact(contact:any){
    this.selectedContact = contact
    console.log(this.selectedContact)
  }
}
